import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import dotracking from "../../../../trackinglogs";
import trackobj from "../../../../trackingpages.json";
import {
  schoolactivelist,
  tourviewdetail,
} from "../../../../../services/superadmin";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  distgroupcreate,
  distgrouplist,
  distgroupschooladd,
  distgroupschooldelete,
  distgroupschoollist,
  distgroupupdate,
} from "../../../../../services/common";
import Select from "react-select";
import { swimdistgrouplist } from "../../../../../services/swimmingapi";

export const DistGroupTourlist = () => {
  const { id } = useParams();
  const [filterProduct, setFilterProduct] = useState([]);
  const [tname, setTName] = useState("");
  const [urllink, setUrlLink] = useState("");
  const [schlist, setSchList] = useState([]);
  const [tsport, setTSport] = useState("");

  useEffect(() => {
    const url = window.location.href;
    const head = url.split("/#/");
    const link = head[1].split("/");
    setUrlLink(link[1]);
    if (localStorage.getItem("Role") === "1") {
      tourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setTSport(response.data.tournament.sports_type);
          listall(response.data.tournament.sports_type);
        }
      });

      schoolactivelist().then((response) => {
        if (response.status === true) {
          let arr1 = [];
          if (response.data.details.length !== 0) {
            for (let i = 0; i < response.data.details.length; i++) {
              arr1.push({
                value: response.data.details[i].id,
                label:
                  response.data.details[i].school_unique_no +
                  " - " +
                  response.data.details[i].school_name,
              });
            }
          }
          setSchList(arr1);
        }
      });
    }
  }, []);

  function listall(ltype) {
    setFilterProduct([]);
    if (ltype.toUpperCase() === "ATHLETICS") {
      distgrouplist(id).then((response) => {
        if (response.status === true) {
          setFilterProduct(response.data.group_list);
        }
      });
    } else if (ltype.toUpperCase() === "SWIMMING") {
      swimdistgrouplist(id).then((response) => {
        if (response.status === true) {
          setFilterProduct(response.data.group_list);
        }
      });
    }
  }

  function backlist() {
    if (localStorage.getItem("Role") === "1") {
      if (tsport.toUpperCase() === "ATHLETICS") {
        dotracking(
          "back button in athletics school list for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.tourschoollistheading
        );
        navigate("/superadmin/athleticschoollist/" + id);
      } else if (tsport.toUpperCase() === "SWIMMING") {
        dotracking(
          "back button in swimming school list for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.tourschoollistheading
        );
        navigate("/superadmin/swimmingschoollist/" + id);
      }
    }
  }

  const columnDefs = [
    {
      headerName: "Action",
      field: "id",
      width: 150,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => gschlist(params.value, params.data)}
              title="Group School List"
              className="btn-sm btn-warning me-2"
            >
              <i className="fa fa-list fa-lg"></i>
            </a>
            <a
              onClick={() => listdet(params.value, params.data)}
              title="Add Schools"
              className="btn-sm btn-secondary me-2"
            >
              <i className="fa fa-plus fa-lg"></i>
            </a>

            <a
              onClick={() => editdet(params.value, params.data)}
              title="Edit Group Name"
              className="btn-sm btn-success me-2"
            >
              <i className="fa fa-edit fa-lg"></i>
            </a>
          </div>
        );
      },
    },

    {
      headerName: "Group Name",
      field: "group_name",
      width: 800,
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  function gschlist(gid, gdata) {
    if (tsport.toUpperCase() === "ATHLETICS") {
      dotracking(
        "athletics district group school list for " +
          gdata.group_name +
          " (" +
          gid +
          ") in " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.grptourschoollistheading
      );
      navigate("/superadmin/athleticgroupschoollist/" + id + "/" + gid);
    } else if (tsport.toUpperCase() === "SWIMMING") {
      dotracking(
        "swimming district group school list for " +
          gdata.group_name +
          " (" +
          gid +
          ") in " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.grptourschoollistheading
      );
      navigate("/superadmin/swimminggroupschoollist/" + id + "/" + gid);
    }
  }

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [gname, setGName] = useState("");
  const [gschool, setGSchool] = useState([]);

  function handleshow() {
    setGName("");
    setGSchool([]);
    setErrMsg("");
    setShow(true);
  }

  function handleclose() {
    setShow(false);
    setGName("");
    setGSchool([]);
    setErrMsg("");
  }

  function handleSchool(e) {
    if (e !== null) {
      setGSchool(e);
    } else {
      setGSchool([]);
    }
  }
  const [errmsg, setErrMsg] = useState("");
  function submitrec(e) {
    e.preventDefault();
    setErrMsg("");
    if (gname !== "") {
      if (grpid === "") {
        if (gschool.length !== 0) {
          var schgrp = "";
          for (let i = 0; i < gschool.length; i++) {
            if (schgrp === "") {
              schgrp = schgrp + gschool[i].value;
            } else {
              schgrp = schgrp + "," + gschool[i].value;
            }
          }
          const temp = new FormData();
          temp.append("tournament_id", id);
          temp.append("group_name", gname);
          temp.append("admin_id", localStorage.getItem("UID"));
          temp.append("school_count", gschool.length);
          for (let i = 0; i < gschool.length; i++) {
            temp.append("school_id_" + [i + 1], gschool[i].value);
          }

          dotracking(
            "submit button in district group list for " +
              gname +
              " with " +
              schgrp +
              " in " +
              tname +
              " (" +
              id +
              ") tournament $$ " +
              trackobj.distgroupheading
          );
          distgroupcreate(temp).then((res) => {
            if (res.status === true) {
              handleclose();
              toast.success(res.message);
              listall(tsport);
            } else {
              setErrMsg(res.message);
            }
          });
        } else {
          setErrMsg("Please Select School");
        }
      } else {
        const temp = new FormData();
        temp.append("admin_id", localStorage.getItem("UID"));
        temp.append("group_name", gname);
        temp.append("group_id", grpid);

        dotracking(
          "update button in district group list for " +
            gname +
            " (" +
            grpid +
            ") in " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.distgroupheading
        );
        distgroupupdate(temp).then((res) => {
          if (res.status === true) {
            handleclose();
            toast.success(res.message);
            listall(tsport);
          } else {
            setErrMsg(res.message);
          }
        });
      }
    } else {
      setErrMsg("Please Enter Group Name");
    }
  }

  function editdet(did, ddata) {
    setGrpID(did);
    setGName(ddata.group_name);
    setShow(true);
    setErrMsg("");
    dotracking(
      "edit group icon in district group list for group - " +
        ddata.group_name +
        " (" +
        did +
        ") in " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.distgroupheading
    );
  }
  const [gslist, setGSList] = useState([]);
  const [grpid, setGrpID] = useState("");
  const [gshow, setGShow] = useState(false);

  function listdet(did, ddata) {
    setGName(ddata.group_name);
    setGrpID(did);
    listschool(did);
    setGSchool([]);
    setErrMsg("");
    dotracking(
      "add school icon in district group list for group - " +
        ddata.group_name +
        " (" +
        did +
        ") in " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.distgroupheading
    );
  }

  function handlegclose() {
    setGName("");
    setGSList([]);
    setGrpID("");
    setGSchool([]);
    setErrMsg("");
    setGShow(false);
  }

  function listschool(lid) {
    setGSList([]);
    distgroupschoollist(id, lid).then((res) => {
      if (res.status === true) {
        setGSList(res.data.group_school_list);
        setGShow(true);
      }
    });
  }
  function deletesch(rid, rname) {
    if (localStorage.getItem("Role") === "1") {
      dotracking(
        "school delete button in district group for " +
          rname +
          " (" +
          rid +
          ") in " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.distgroupheading
      );
      const temp = new FormData();
      temp.append("tournament_id", id);
      temp.append("group_id", grpid);
      temp.append("school_id", rid);

      distgroupschooldelete(temp).then((response) => {
        if (response.status === true) {
          listschool(grpid);
        }
      });
    }
  }

  function submitsch(e) {
    e.preventDefault();
    if (gschool.length !== 0) {
      var schgrp = "";
      for (let i = 0; i < gschool.length; i++) {
        if (schgrp === "") {
          schgrp = schgrp + gschool[i].value;
        } else {
          schgrp = schgrp + "," + gschool[i].value;
        }
      }
      const temp = new FormData();
      temp.append("tournament_id", id);
      temp.append("group_id", grpid);
      temp.append("admin_id", localStorage.getItem("UID"));
      temp.append("school_count", gschool.length);
      for (let i = 0; i < gschool.length; i++) {
        temp.append("school_id_" + [i + 1], gschool[i].value);
      }
      distgroupschooladd(temp).then((res) => {
        if (res.status === true) {
          handlegclose();
          toast.success(res.message);
          listall(tsport);
        } else {
          setErrMsg(res.message);
        }
      });
    } else {
      setErrMsg("Please Select School");
    }
  }

  //   function deleterec(ddata) {
  //     Swal.fire({
  //       title: "Are you sure want to delete?",
  //       showCancelButton: true,
  //       confirmButtonColor: "#d71635",
  //       confirmButtonText: "Ok",
  //       allowOutsideClick: false,
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         dotracking(
  //           "delete icon in tournament receipt list for school - " +
  //             ddata.school_name +
  //             " (" +
  //             ddata.school_id +
  //             ") in " +
  //             tname +
  //             " (" +
  //             id +
  //             ") tournament $$ " +
  //             trackobj.tourreceiptlistheading
  //         );
  //         receiptdelete(ddata.id, id, ddata.school_id).then((res) => {
  //           if (res.status === true) {
  //             toast.success(res.message);
  //             listall(tsport);
  //           }
  //         });
  //       }
  //     });
  //   }

  return (
    <Fragment>
      <div className="side-app">
        <div className="page-header">
          <div className="breadcrumb">
            <h4 className="mb-0">District Groups Lists</h4>
          </div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Tournament</a>
            </li>

            <li className="breadcrumb-item active" aria-current="page">
              District Groups Lists
            </li>
          </ol>
        </div>

        <div className="row">
          <div className="col-12">
            <form className="card mt-0">
              <div className="card-body">
                <div className="row pb-3">
                  <div className="col-md-9">
                    <div className="text-left">
                      <h3 className="mb-2">{tname}</h3>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="text-right">
                      <a className="btn btn-success me-2" onClick={handleshow}>
                        <i className="fa fa-plus"></i> Add Group
                      </a>
                      <a onClick={backlist} className="btn btn-gray">
                        <i className="fe fe-corner-up-left"></i> Back
                      </a>
                    </div>
                  </div>
                </div>
                <div className="ag-theme-alpine ag-style">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressExcelExport={true}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>

                <Modal show={show} size="md">
                  <Modal.Header>
                    {grpid === "" && <h4>Add Group With Schools</h4>}
                    {grpid !== "" && <h4>Group Details</h4>}
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="form-label">
                            Group Name <span className="errortext"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Group Name"
                            onChange={(e) => setGName(e.target.value)}
                            value={gname}
                          />
                        </div>
                      </div>
                      {grpid === "" && (
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="form-label">
                              School <span className="errortext"> *</span>
                            </label>
                            <Select
                              className="dropdown"
                              placeholder="Select School"
                              value={gschool}
                              options={schlist}
                              onChange={handleSchool}
                              isSearchable={true}
                              isMulti
                              isClearable
                              hidden
                            />
                          </div>
                        </div>
                      )}
                      {errmsg !== "" && (
                        <span className="errortext"> {errmsg}</span>
                      )}
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="text-right">
                      {grpid === "" && (
                        <a className="btn btn-success me-2" onClick={submitrec}>
                          {" "}
                          Submit
                        </a>
                      )}

                      {grpid !== "" && (
                        <a className="btn btn-success me-2" onClick={submitrec}>
                          {" "}
                          Update
                        </a>
                      )}
                      <a className="btn btn-gray" onClick={handleclose}>
                        {" "}
                        Close
                      </a>
                    </div>
                  </Modal.Footer>
                </Modal>

                <Modal show={gshow} size="md">
                  <Modal.Header>
                    <h4>Add Schools - {gname}</h4>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="form-label">
                            School <span className="errortext"> *</span>
                          </label>
                          <Select
                            className="dropdown"
                            placeholder="Select School"
                            value={gschool}
                            options={schlist}
                            onChange={handleSchool}
                            isSearchable={true}
                            isMulti
                            isClearable
                            hidden
                          />
                        </div>
                      </div>

                      <div className="details-group refereebox deletereferee">
                        <div className="row">
                          {gslist.map((data, i) => {
                            return (
                              <div
                                className="col-md-6 align-self-center"
                                key={i}
                              >
                                <div className="form-group">
                                  <h4 className="mb-1">{data.school_name}</h4>

                                  <a
                                    className="deleterefer"
                                    onClick={() =>
                                      deletesch(
                                        data.school_group_id,
                                        data.school_name
                                      )
                                    }
                                  >
                                    <i className="fa fa-close"></i>
                                  </a>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      {errmsg !== "" && (
                        <span className="errortext"> {errmsg}</span>
                      )}
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="text-right">
                      <a className="btn btn-success me-2" onClick={submitsch}>
                        {" "}
                        Submit
                      </a>
                      <a className="btn btn-gray" onClick={handlegclose}>
                        {" "}
                        Close
                      </a>
                    </div>
                  </Modal.Footer>
                </Modal>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
